import BaseApi from './BaseApi';

export const productsApi = new BaseApi({
  urlPrefix: '/web/api',
});
